import { createFileRoute } from '@tanstack/react-router'
import { parse } from 'valibot'

import { fetchTariffContract } from '@/features/contracts/api'

import { contractParamsSchema } from '../../-models'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/contracts/tariff/$contractId'
)({
  parseParams: (params) => parse(contractParamsSchema, params),
  loader: async ({
    abortController,
    params: { tenantKey, contractId },
    context: { auth }
  }) => {
    return {
      authUser: auth.user,
      contract: await fetchTariffContract(
        {
          tenantKey,
          contractId
        },
        abortController.signal
      )
    }
  },
  meta: ({ loaderData }) => [
    {
      title: loaderData.contract.name
    }
  ]
})
